import { useCoupon, useGclid, useReferralToken } from '@hooks/params';

export const useController = () => {
  useCoupon();
  useGclid();
  useReferralToken();
};
